import { render, staticRenderFns } from "./CreateEditTemplate.vue?vue&type=template&id=701d31ed"
import script from "./CreateEditTemplate.vue?vue&type=script&lang=js"
export * from "./CreateEditTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateEditTemplate.vue?vue&type=style&index=0&id=701d31ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports